import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { AppMoodUpdatePage } from './app-mood-update';
import {PipesModule} from "../../pipes/pipes.module";
import {DirectivesModule} from "../../directives/directives.module";
import {ComponentsModule} from "../../components/components.module";

@NgModule({
  declarations: [
    AppMoodUpdatePage,
  ],
  imports: [
    IonicPageModule.forChild(AppMoodUpdatePage),
    PipesModule,
    DirectivesModule,

    ComponentsModule,
  ],
})
export class AppMoodUpdatePageModule {}



// WEBPACK FOOTER //
// ./src/pages/app-mood-update/app-mood-update.module.ts